import { render, staticRenderFns } from "./LegalContentLayout.vue?vue&type=template&id=7205af85&scoped=true"
import script from "./LegalContentLayout.vue?vue&type=script&lang=js"
export * from "./LegalContentLayout.vue?vue&type=script&lang=js"
import style0 from "./LegalContentLayout.vue?vue&type=style&index=0&id=7205af85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7205af85",
  null
  
)

export default component.exports